<template>
  <div class="flex w-full justify-center items-center">
    <skeleton v-if="data.objectID === 'skeleton'" width="72px" height="40px" />
    <button
      v-else
      class="w-[72px] h-[40px] font-montserrat font-semibold text-sm text-university-secondary uppercase bg-white border border-university-secondary"
      @click.prevent="impersonateClick(data.student)"
    >
      {{ label }}
    </button>
  </div>
</template>
<script setup>
import { inject } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

import Skeleton from "primevue/skeleton";

const store = useStore();
const router = useRouter();
const route = useRoute();
import userService from "@/services/user";

const props = defineProps({
  label: {
    type: String,
    default: "VIEW",
  },
  data: {
    type: Object,
    default: undefined,
  },
});

const setLoading = inject("setLoading");

const impersonateClick = (student) => {
  if (!student?.email) return;
  setLoading(true);
  userService.impersonate(student.email).then(async ({ currentUser, token, studentFormioResource }) => {
    localStorage.setItem("formioUser", JSON.stringify(studentFormioResource));
    localStorage.setItem("formioToken", token);
    sessionStorage.setItem("impersonationModeReturnUrl", route.fullPath);
    store.commit("setFormioUser");
    store.commit("setCurrentUser", currentUser);
    router.push({ name: "applications" });
  });
};
</script>
